// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sewaddle: PokeData = {
  "id": 540,
  "name": "sewaddle",
  "height": 3,
  "weight": 25,
  "base_experience": 62,
  "types": [
    PokeType.BUG,
    PokeType.GRASS
  ],
  "api_moves": [
    "tackle",
    "razor-leaf",
    "string-shot",
    "flail",
    "endure",
    "bug-buzz",
    "bug-bite",
    "struggle-bug",
    "sticky-web"
  ],
  "moves": [
    "tackle",
    "razor-leaf",
    "string-shot",
    "bug-buzz",
    "bug-bite",
    "sticky-web",
    "signal-spam",
    "pin-rush",
    "vine-whip",
    "grassy-terrain",
    "power-whip",
    "heal-order",
    "lunge"
  ],
  "evolution_chain": {
    "id": 276,
    "item": null,
    "species": [
      {
        "name": "sewaddle",
        "order": 541,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "swadloon",
        "order": 542,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 540,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "leavanny",
        "order": 543,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 541,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 220,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 42,
    "ability_power": 53
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
